import { keepPreviousData, useMutation, useQuery } from '@tanstack/react-query'
import { AxiosResponse } from 'axios'

import { omitRequestParams } from '../utils.ts'
import { ApiErrorResponse, CreateTemplateRequestParams, TableData, TemplatePayment } from '../types.ts'

import { apiService } from './root.ts'
import { MessageResponse } from './services.types.ts'
import { useAppSelector } from '@/stores/hooks.ts'
import { templatesSelectors } from '@/stores/slices/templates-slice.ts'

export const TEMPLATES_ROOT = '/payment-templates'

export const TEMPLATES_ENDPOINTS = {
  list: TEMPLATES_ROOT,
  item: (id: string) => `${TEMPLATES_ROOT}/${id}`,
  sendUrl: `${TEMPLATES_ROOT}/sendUrl`,
}

export const TEMPLATES_QUERY_KEYS = {
  list: 'templates_list',
  item: 'template_item',
}

export const useGetTemplatePayments = () => {
  const { page, showCount } = useAppSelector(templatesSelectors.filters)
  // paymentInfoShort
  const [sortField, direction] = useAppSelector((state) => state.templates.sort) || []

  const queryParams = omitRequestParams({
    page,
    showCount,
    // state: state === 'ALL' ? undefined : state,
    sortField,
    direction,
  })

  return useQuery({
    placeholderData: keepPreviousData,
    queryKey: [TEMPLATES_QUERY_KEYS.list, queryParams],
    queryFn: () => apiService.get<TableData<TemplatePayment>>(TEMPLATES_ENDPOINTS.list, { queryParams }),
  })
}

export const useGetTemplatePayment = (id: string) =>
  useQuery({
    queryKey: [TEMPLATES_QUERY_KEYS.item, { id }],
    queryFn: () => apiService.get<TemplatePayment>(TEMPLATES_ENDPOINTS.item(id)),
  })

export const useMutateCreateTemplate = () =>
  useMutation({
    mutationFn: (bodyParams: CreateTemplateRequestParams) => apiService.post(TEMPLATES_ENDPOINTS.list, { bodyParams }),
  })

export const useMutateDeleteTemplate = (id: number) =>
  useMutation<AxiosResponse<MessageResponse>, AxiosResponse<ApiErrorResponse>, void, unknown>({
    mutationFn: () => apiService.delete<MessageResponse>(TEMPLATES_ENDPOINTS.item(id.toString())),
  })
